<template>
	<a-upload  name="file" list-type="picture-card" class="avatar-uploader"
		:show-upload-list="false" :before-upload="beforeUpload" @change="handleChange" accept="image/*" :customRequest="handleUpload">
		<div class="image-wrapper" v-if="!loading && url">
			<img class="image" :src="url" alt="avatar" />

			<a class="remove" href="javascript:;" @click.stop="$emit('remove')">
				<svg width="24" height="24" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z"
						fill="#f50" stroke="#f50" stroke-width="3" stroke-linejoin="bevel" />
					<path d="M29.6567 18.3432L18.343 29.6569" stroke="#FFF" stroke-width="3" stroke-linecap="round"
						stroke-linejoin="bevel" />
					<path d="M18.3433 18.3432L29.657 29.6569" stroke="#FFF" stroke-width="3" stroke-linecap="round"
						stroke-linejoin="bevel" />
				</svg>
			</a>
		</div>
		<div v-else>
			<a-icon :type="loading ? 'loading' : 'plus'" />
		</div>
	</a-upload>
</template>
<script>
import { upload } from '@/utils';

const logo178 = require('@/assets/images/favicon_178.png')
const logo007 = require('@/assets/images/favicon_007.png')
const logo360 = require('@/assets/images/favicon_360.png')

async function loadImage(src) {
	return new Promise((resolve) => {
		const logo = new Image();
		logo.onload = function () {
			resolve(logo)
		};
		logo.src = src
	})
}

async function compressQualityOnly(file, quality = 0.7, platform) {
	const img = await createImageBitmap(file);
	const canvas = new OffscreenCanvas(img.width, img.height);
	const ctx = canvas.getContext('2d');
	ctx.drawImage(img, 0, 0);
	var logo = null
	var position = img.width / 27.428571428571427
	if (platform == 'qrcode_178') {
		logo = await loadImage(logo178)
	} else if (platform == 'qrcode_yiqi8') {
		logo = await loadImage(logo007)
	} else if (platform == 'qrcode_360') {
		logo = await loadImage(logo360)
	}
	if (logo) {
		ctx.drawImage(logo, position, position, img.width / 4, img.width / 15.483870967741936);
	}
	return await canvas.convertToBlob({
		type: file.type,
		quality: Math.min(Math.max(0, quality), 1)
	});
}

export default {
	props: {
		url: {
			type: String,
			default: "",
		},
		platform: {
			type: String,
			default: "",
		},
		prefix: {
			type: String,
			default: "static/",
		},
		removable: {
			type: Boolean,
			default: false
		},
		type: {
			type: String,
			default: 'cover'
		},
		scene: {
			type: String,
			default: 'user_avatar'
		}
	},
	data() {
		return {
			loading: false,
			cdnhost: "",
			data: {
				token: "",
				key: "",
			},
			fileData: null
		};
	},
	methods: {
		handleChange(info) {
			console.info("upload.change", info);
			if (info.file.status === "uploading") {
				this.loading = true;
				return;
			} else if (info.file.status === "error") {
				this.$message.error("封面图上传失败，请检查网络后重试");
				this.loading = false;
				return;
			}
			if (info.file.status === "done") {
				this.loading = false;
				const { response } = info.file;
				response.url = this.cdnhost;
				this.$emit("success", response);
			}
		},
		async beforeUpload(file) {
			const f = await this.checkImage(file)
			if (f) {
				this.fileData = file
				return f
			}
			return Promise.reject(false);
		},
		async handleUpload({ file, onSuccess, onError }) {
			try {
				file = this.fileData
				const { url } = await upload(file, { scene: this.scene });
				this.cdnhost = url;
				onSuccess({ url })
			} catch (e) {
				onError(e)
			}
		},
		async checkImage(f) {
			const file = await compressQualityOnly(f, 1, this.type == 'cover' ? this.platform : '')
			return new Promise((resolve) => {
				if (!['image/png', 'image/jpg', 'image/jpeg'].includes(file.type)) {
					this.$message.error("请上传图片(png,jpg,jpeg)");
					return resolve(false);
				}
				if (file.size > 1024 * 1024 * 2) {
					this.$message.error("请不要上传超过2MB!");
					return resolve(false);
				}
				const m = new Image()
				const url = URL.createObjectURL(file);
				m.onload = () => {
					URL.revokeObjectURL(url);
					const aspectRatio = m.width / m.height;
					if (this.type == 'cover') {
						if (Math.abs(aspectRatio - 16 / 9) < 0.02) {
							resolve(file)
						} else {
							this.$message.error("请上传16:9的图片!");
							resolve(false);
						}
					} else if (this.type == 'qrcode') {
						if (Math.abs(aspectRatio - 1) < 0.01) {
							resolve(file)
						} else {
							this.$message.error("请上传1:1的图片!");
							resolve(false);
						}
					} else {
						resolve(false)
					}
				}
				m.onerror = function () {
					resolve(false);
				}
				m.src = url
			})
		}
	},
};
</script>
<style>
.avatar-uploader>.ant-upload {
	width: 128px;
	height: 128px;
}


.avatar-uploader>.ant-upload .image-wrapper {
	position: relative;
	width: 110px;
	height: 110px;
}

.avatar-uploader>.ant-upload .image-wrapper .remove {
	position: absolute;
	top: -20px;
	right: -20px;

}

.avatar-uploader>.ant-upload .image {
	display: block;
	width: 100%;
	height: 100%;
	object-fit: contain;
}

.ant-upload-select-picture-card i {
	font-size: 32px;
	color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
	margin-top: 8px;
	color: #666;
}
</style>
